(ns frontend.view.entity-merge.kpi
  (:require [clojure.set :as set]
            [common.entity :as entity]
            [common.localization :as loc]
            [common.util :as cu]
            [frontend.state.current-session :as session]
            [frontend.view.entity-merge.components :as components]
            [frontend.view.entity-merge.events :as events]))

(defmethod components/step-info :kpi [{:keys [entity-type] :as signals} [step-kw _step-params]]
  (loc/tr :reports/kpi-reporting))

(defn review [{:keys [state r-target r-source] :as signals}]
  (let [source @r-source
        source-id (:db/id source)
        source-name (entity/display-string source)
        target @r-target
        target-id (:db/id target)
        target-name (entity/display-string target)
        source-members (->> @session/kpi-members
                            (cu/filter-by :kpi-member/asset source-id))
        source-categories (->> source-members
                               (keep :kpi-member/target)
                               (keep session/get-entity)
                               (remove :common/disabled?))
        target-members (->> @session/kpi-members
                            (cu/filter-by :kpi-member/asset target-id))
        target-categories (->> target-members
                               (keep :kpi-member/target)
                               (keep session/get-entity)
                               (remove :common/disabled?))]
    [components/review-card signals
     {:title (loc/tr :kpi-merge-title)
      :collapsed-path [:kpi]
      :content
      [:div
       (loc/tr :merge-kpi-info [source-name])
       (doall
        (for [{:keys [db/id] :as kpi-category} source-categories]
          ^{:key (str "kpi-category-" id)}
          [:div.text-bold
           (entity/display-string kpi-category :long)]))]}]))

;;note: only review step used for now. selection between merge-source/merge-target as the
;; surviving KPI asset can be implemented later:
(defn view [{:keys [state r-source r-target] :as signals}]
  (let [rejection-path [:rejection :kpi]
        toggle-guest! (partial events/toggle! state rejection-path)]
    (fn [{:keys [r-source r-target] :as signals}]
      (let [source-id (:db/id @r-source)
            target-id (:db/id @r-target)
            source-members (->> @session/kpi-members
                                (cu/filter-by :kpi-member/asset source-id))
            source-categories (->> source-members
                                   (keep :kpi-member/target)
                                   (keep session/get-entity)
                                   (remove :common/disabled?))
            target-members (->> @session/kpi-members
                                (cu/filter-by :kpi-member/asset target-id))
            target-categories (->> target-members
                                   (keep :kpi-member/target)
                                   (keep session/get-entity)
                                   (remove :common/disabled?))
            both (set/intersection (set source-categories)
                                   (set target-categories))
            ;; both are members in same kpi-category
            ;; => -disable source membership (just discard all source kpi entities)
            ;;     => ^ first release
            ;;     -potential improvements:
            ;;      -if no target-report for certain kpi-cycle, move source-report
            ;;       (i.e. change :kpi-report/company from source to target)
            ;;      -if reports for a kpi-cycle exist for both target and source, discard source report
            ;;       -potential improvement:
            ;;        -if no kpi-data (and/or kpi-answer) for target for certain period (YYYY-MM) but
            ;;         there is for source => move source kpi-data/-answer as target kpi-data/-answer
            ;;         -if both => discard source-data (or based on selection?)
            ;;
            ;; do we allow selection or only show info?
            rejection (get-in @state rejection-path)]
        [:div.asset-updater-table__fields
         [:div.asset-updater-table__field
          [:div.asset-updater-table__compare
           [:div
            {:class-name "mt-4 grid grid-cols-1 gap-4"}
            [:div
             (for [category both
                   :let [{category-name :kpi-category/name
                          category-id :db/id} category]]
               ^{:key (str "both-" category-id)}
               [:div category-name])]]

           [:div
            {:class-name "mt-4 grid grid-cols-2 gap-4"}
            [:div
             (for [category source-categories
                   :let [{category-name :kpi-category/name
                          category-id :db/id} category]]
               ^{:key (str "both-" category-id)}
               [:div category-name])]

            [:div
             (for [category target-categories
                   :let [{category-name :kpi-category/name
                          category-id :db/id} category]]
               ^{:key (str "both-" category-id)}
               [:div category-name])]]]]]))))
